import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useBarChartLabelStyles } from '../../utils/styles.esm.js';

const BarChartLabel = ({
  x,
  y,
  height,
  width,
  details,
  children
}) => {
  const classes = useBarChartLabelStyles();
  const translateX = width * -0.5;
  return /* @__PURE__ */ React.createElement(
    "foreignObject",
    {
      className: classes.foreignObject,
      style: { transform: `translateX(${translateX}px)` },
      x,
      y,
      height,
      width
    },
    /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center" }, /* @__PURE__ */ React.createElement(Typography, { className: classes.label, gutterBottom: true }, children), details)
  );
};

export { BarChartLabel };
//# sourceMappingURL=BarChartLabel.esm.js.map
